import React from "react";
import Bedroom from "./Bedroom";


const Bedrooms = (props) => {

	return (
		<div className={'levels'}>
			{props.data.map((bedroom, index) => <Bedroom key={index} index={index} data={bedroom} status={props.status} statusChange={props.statusChange} appName={props.appName} dataType={props.dataType}/>)}
		</div>
	);
};

export default Bedrooms;